module.exports = __webpack_public_path__ + "static/UnclickDamageLossYellow-362cc1c94d6830c44f8c534119981856.png";